import { initChartWithStats } from '../../../vendor/chartjs';

document.addEventListener('turbo:load', function() {
  
  /* --------------------------------------------------
                Create Chart
  -------------------------------------------------- */
  const pagesJobsViewShowActivityCreateChart = () => {
    const canvas = document.getElementById('activityChart');
    if (!canvas) return;
    const statViews = document.querySelector('[data-stat-chartjs="views"]');
    const statPlanholders = document.querySelector('[data-stat-chartjs="planholders"]');
    const chartViews = JSON.parse(canvas.getAttribute('data-views'));
    const chartPlanholders = JSON.parse(canvas.getAttribute('data-planholders'));
    const chartLabels = JSON.parse(canvas.getAttribute('data-labels'));
    // Get label interval from data attribute, default to 1 (show all labels)
    const labelInterval = parseInt(canvas.getAttribute('data-label-interval') || '1', 10);
    const chartDatasets = [
      {
        label: 'Views',
        data: chartViews,
        borderColor: statViews.getAttribute('data-stat-chartjs-color'),
        backgroundColor: statViews.getAttribute('data-stat-chartjs-background-color')
      },
      {
        label: 'Planholders',
        data: chartPlanholders,
        borderColor: statPlanholders.getAttribute('data-stat-chartjs-color'),
        backgroundColor: statPlanholders.getAttribute('data-stat-chartjs-background-color')
      }
    ];

    // Initialize Chart
    initChartWithStats({
      canvas: 'activityChart',
      datasets: chartDatasets,
      labels: chartLabels,
      defaultDataset: 'views',
      options: {
        scales: {
          x: {
            ticks: {
              callback: function(value, index) {
                // Show label only for every nth index (based on data-label-interval)
                return index % labelInterval === 0 ? chartLabels[index] : '';
              }
            }
          }
        }
      }
    });
  };

  /* --------------------------------------------------
                Functions
  -------------------------------------------------- */
  pagesJobsViewShowActivityCreateChart();
});
